// extracted by mini-css-extract-plugin
module.exports = {"noBullets":"appointments_noBullets__It9Qt"};